import React from 'react';

const PageHeader = ({ title, subtitle, action }) => {
  return (
    <div className="mb-4 sm:mb-6 md:mb-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div className="w-full sm:w-auto">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-normal text-[#55C5D0] mb-1 sm:mb-2">{title}</h1>
          {subtitle && <p className="text-sm sm:text-base text-gray-600">{subtitle}</p>}
        </div>
        {action && <div className="w-full sm:w-auto flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
};

export default PageHeader;

